// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/conversations/v1/conversations.proto" (package "c1.api.conversations.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { UIMessagesSearchService } from "./conversations";
import type { UIMessagesSearchServiceSearchResponse } from "./conversations";
import type { UIMessagesSearchServiceSearchRequest } from "./conversations";
import { UIMessagesService } from "./conversations";
import type { UIMessagesServiceCreateFeedbackResponse } from "./conversations";
import type { UIMessagesServiceCreateFeedbackRequest } from "./conversations";
import type { UIMessagesServiceSendResponse } from "./conversations";
import type { UIMessagesServiceSendRequest } from "./conversations";
import type { UIMessagesServiceListResponse } from "./conversations";
import type { UIMessagesServiceListRequest } from "./conversations";
import { UIConversationsSearchService } from "./conversations";
import type { GetSearchTermsResponse } from "./conversations";
import type { GetSearchTermsRequest } from "./conversations";
import type { SearchResponse } from "./conversations";
import type { SearchRequest } from "./conversations";
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { UIConversationsService } from "./conversations";
import type { UIConversationsServiceListTicketBindingsResponse } from "./conversations";
import type { UIConversationsServiceListTicketBindingsRequest } from "./conversations";
import type { UIConversationsServiceMutateConfigResponse } from "./conversations";
import type { UIConversationsServiceMutateConfigRequest } from "./conversations";
import type { UIConversationsServiceGetConfigResponse } from "./conversations";
import type { UIConversationsServiceGetConfigRequest } from "./conversations";
import type { UIConversationsServiceMutateResponse } from "./conversations";
import type { UIConversationsServiceMutateRequest } from "./conversations";
import type { UIConversationsServiceDeleteResponse } from "./conversations";
import type { UIConversationsServiceDeleteRequest } from "./conversations";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { UIConversationsServiceCreateResponse } from "./conversations";
import type { UIConversationsServiceCreateRequest } from "./conversations";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.conversations.v1.UIConversationsService
 */
export interface IUIConversationsServiceClient {
    /**
     * @generated from protobuf rpc: Create
     */
    create(input: UIConversationsServiceCreateRequest, options?: RpcOptions): UnaryCall<UIConversationsServiceCreateRequest, UIConversationsServiceCreateResponse>;
    /**
     * @generated from protobuf rpc: Delete
     */
    delete(input: UIConversationsServiceDeleteRequest, options?: RpcOptions): UnaryCall<UIConversationsServiceDeleteRequest, UIConversationsServiceDeleteResponse>;
    /**
     * @generated from protobuf rpc: Mutate
     */
    mutate(input: UIConversationsServiceMutateRequest, options?: RpcOptions): UnaryCall<UIConversationsServiceMutateRequest, UIConversationsServiceMutateResponse>;
    /**
     * @generated from protobuf rpc: GetConfig
     */
    getConfig(input: UIConversationsServiceGetConfigRequest, options?: RpcOptions): UnaryCall<UIConversationsServiceGetConfigRequest, UIConversationsServiceGetConfigResponse>;
    /**
     * @generated from protobuf rpc: MutateConfig
     */
    mutateConfig(input: UIConversationsServiceMutateConfigRequest, options?: RpcOptions): UnaryCall<UIConversationsServiceMutateConfigRequest, UIConversationsServiceMutateConfigResponse>;
    /**
     * @generated from protobuf rpc: ListTicketBindings
     */
    listTicketBindings(input: UIConversationsServiceListTicketBindingsRequest, options?: RpcOptions): UnaryCall<UIConversationsServiceListTicketBindingsRequest, UIConversationsServiceListTicketBindingsResponse>;
}
/**
 * @generated from protobuf service c1.api.conversations.v1.UIConversationsService
 */
export class UIConversationsServiceClient implements IUIConversationsServiceClient, ServiceInfo {
    typeName = UIConversationsService.typeName;
    methods = UIConversationsService.methods;
    options = UIConversationsService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Create
     */
    create(input: UIConversationsServiceCreateRequest, options?: RpcOptions): UnaryCall<UIConversationsServiceCreateRequest, UIConversationsServiceCreateResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<UIConversationsServiceCreateRequest, UIConversationsServiceCreateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Delete
     */
    delete(input: UIConversationsServiceDeleteRequest, options?: RpcOptions): UnaryCall<UIConversationsServiceDeleteRequest, UIConversationsServiceDeleteResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<UIConversationsServiceDeleteRequest, UIConversationsServiceDeleteResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Mutate
     */
    mutate(input: UIConversationsServiceMutateRequest, options?: RpcOptions): UnaryCall<UIConversationsServiceMutateRequest, UIConversationsServiceMutateResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<UIConversationsServiceMutateRequest, UIConversationsServiceMutateResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetConfig
     */
    getConfig(input: UIConversationsServiceGetConfigRequest, options?: RpcOptions): UnaryCall<UIConversationsServiceGetConfigRequest, UIConversationsServiceGetConfigResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<UIConversationsServiceGetConfigRequest, UIConversationsServiceGetConfigResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: MutateConfig
     */
    mutateConfig(input: UIConversationsServiceMutateConfigRequest, options?: RpcOptions): UnaryCall<UIConversationsServiceMutateConfigRequest, UIConversationsServiceMutateConfigResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<UIConversationsServiceMutateConfigRequest, UIConversationsServiceMutateConfigResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListTicketBindings
     */
    listTicketBindings(input: UIConversationsServiceListTicketBindingsRequest, options?: RpcOptions): UnaryCall<UIConversationsServiceListTicketBindingsRequest, UIConversationsServiceListTicketBindingsResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<UIConversationsServiceListTicketBindingsRequest, UIConversationsServiceListTicketBindingsResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.conversations.v1.UIConversationsSearchService
 */
export interface IUIConversationsSearchServiceClient {
    /**
     * @generated from protobuf rpc: Search
     */
    search(input: SearchRequest, options?: RpcOptions): UnaryCall<SearchRequest, SearchResponse>;
    /**
     * @generated from protobuf rpc: GetSearchTerms
     */
    getSearchTerms(input: GetSearchTermsRequest, options?: RpcOptions): UnaryCall<GetSearchTermsRequest, GetSearchTermsResponse>;
}
/**
 * @generated from protobuf service c1.api.conversations.v1.UIConversationsSearchService
 */
export class UIConversationsSearchServiceClient implements IUIConversationsSearchServiceClient, ServiceInfo {
    typeName = UIConversationsSearchService.typeName;
    methods = UIConversationsSearchService.methods;
    options = UIConversationsSearchService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Search
     */
    search(input: SearchRequest, options?: RpcOptions): UnaryCall<SearchRequest, SearchResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchRequest, SearchResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetSearchTerms
     */
    getSearchTerms(input: GetSearchTermsRequest, options?: RpcOptions): UnaryCall<GetSearchTermsRequest, GetSearchTermsResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetSearchTermsRequest, GetSearchTermsResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.conversations.v1.UIMessagesService
 */
export interface IUIMessagesServiceClient {
    /**
     * @generated from protobuf rpc: List
     */
    list(input: UIMessagesServiceListRequest, options?: RpcOptions): UnaryCall<UIMessagesServiceListRequest, UIMessagesServiceListResponse>;
    /**
     * @generated from protobuf rpc: Send
     */
    send(input: UIMessagesServiceSendRequest, options?: RpcOptions): UnaryCall<UIMessagesServiceSendRequest, UIMessagesServiceSendResponse>;
    /**
     * @generated from protobuf rpc: CreateFeedback
     */
    createFeedback(input: UIMessagesServiceCreateFeedbackRequest, options?: RpcOptions): UnaryCall<UIMessagesServiceCreateFeedbackRequest, UIMessagesServiceCreateFeedbackResponse>;
}
/**
 * @generated from protobuf service c1.api.conversations.v1.UIMessagesService
 */
export class UIMessagesServiceClient implements IUIMessagesServiceClient, ServiceInfo {
    typeName = UIMessagesService.typeName;
    methods = UIMessagesService.methods;
    options = UIMessagesService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: List
     */
    list(input: UIMessagesServiceListRequest, options?: RpcOptions): UnaryCall<UIMessagesServiceListRequest, UIMessagesServiceListResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<UIMessagesServiceListRequest, UIMessagesServiceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Send
     */
    send(input: UIMessagesServiceSendRequest, options?: RpcOptions): UnaryCall<UIMessagesServiceSendRequest, UIMessagesServiceSendResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<UIMessagesServiceSendRequest, UIMessagesServiceSendResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateFeedback
     */
    createFeedback(input: UIMessagesServiceCreateFeedbackRequest, options?: RpcOptions): UnaryCall<UIMessagesServiceCreateFeedbackRequest, UIMessagesServiceCreateFeedbackResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<UIMessagesServiceCreateFeedbackRequest, UIMessagesServiceCreateFeedbackResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.conversations.v1.UIMessagesSearchService
 */
export interface IUIMessagesSearchServiceClient {
    /**
     * @generated from protobuf rpc: Search
     */
    search(input: UIMessagesSearchServiceSearchRequest, options?: RpcOptions): UnaryCall<UIMessagesSearchServiceSearchRequest, UIMessagesSearchServiceSearchResponse>;
}
/**
 * @generated from protobuf service c1.api.conversations.v1.UIMessagesSearchService
 */
export class UIMessagesSearchServiceClient implements IUIMessagesSearchServiceClient, ServiceInfo {
    typeName = UIMessagesSearchService.typeName;
    methods = UIMessagesSearchService.methods;
    options = UIMessagesSearchService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Search
     */
    search(input: UIMessagesSearchServiceSearchRequest, options?: RpcOptions): UnaryCall<UIMessagesSearchServiceSearchRequest, UIMessagesSearchServiceSearchResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<UIMessagesSearchServiceSearchRequest, UIMessagesSearchServiceSearchResponse>("unary", this._transport, method, opt, input);
    }
}
